import React from 'react';
import Grid from '@mui/material/GridLegacy';
import {
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { Place, People, Campaign, BarChart } from '@mui/icons-material';

export default function OverviewTab({
  stats = {},
  analytics = {},
  categories = [],
  tags = [],
}) {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 4, fontWeight: 700, color: 'text.primary' }}>
        Dashboard Overview
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              height: '100%',
              borderRadius: 3,
              boxShadow: '0 8px 24px rgba(102, 126, 234, 0.4)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 32px rgba(102, 126, 234, 0.5)',
              },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                filter: 'blur(20px)',
              }}
            />
            <CardContent sx={{ position: 'relative', zIndex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, opacity: 0.95 }}>Total Places</Typography>
                <Box sx={{ p: 1.5, borderRadius: 2, background: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(10px)' }}>
                  <Place sx={{ fontSize: 32 }} />
                </Box>
              </Box>
              <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>{stats.totalPlaces || 0}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>Active locations</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              color: 'white',
              height: '100%',
              borderRadius: 3,
              boxShadow: '0 8px 24px rgba(240, 147, 251, 0.4)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 32px rgba(240, 147, 251, 0.5)',
              },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                filter: 'blur(20px)',
              }}
            />
            <CardContent sx={{ position: 'relative', zIndex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, opacity: 0.95 }}>Total Users</Typography>
                <Box sx={{ p: 1.5, borderRadius: 2, background: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(10px)' }}>
                  <People sx={{ fontSize: 32 }} />
                </Box>
              </Box>
              <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>{stats.totalUsers || 0}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>Registered users</Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
              color: 'white',
              height: '100%',
              borderRadius: 3,
              boxShadow: '0 8px 24px rgba(79, 172, 254, 0.4)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 32px rgba(79, 172, 254, 0.5)',
              },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                filter: 'blur(20px)',
              }}
            />
            <CardContent sx={{ position: 'relative', zIndex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 500, opacity: 0.95 }}>Banners</Typography>
                <Box sx={{ p: 1.5, borderRadius: 2, background: 'rgba(255, 255, 255, 0.2)', backdropFilter: 'blur(10px)' }}>
                  <Campaign sx={{ fontSize: 32 }} />
                </Box>
              </Box>
              <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>{stats.totalBanners || 0}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>Active banners</Typography>
            </CardContent>
          </Card>
        </Grid>

      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card
            sx={{
              height: '100%',
              borderRadius: 3,
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              transition: 'all 0.3s ease',
              '&:hover': { boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)' },
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, pb: 2, borderBottom: '2px solid', borderColor: 'divider' }}>
                <Box sx={{ p: 1.5, borderRadius: 2, background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', mr: 2 }}>
                  <BarChart sx={{ color: 'white', fontSize: 24 }} />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Quick Stats</Typography>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      p: 3,
                      background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                      borderRadius: 3,
                      textAlign: 'center',
                      border: '1px solid rgba(102, 126, 234, 0.2)',
                      transition: 'all 0.3s ease',
                      '&:hover': { transform: 'scale(1.05)', boxShadow: '0 4px 12px rgba(102, 126, 234, 0.2)' },
                    }}
                  >
                    <Typography variant="h3" sx={{ fontWeight: 700, color: 'primary.main', mb: 0.5 }}>
                      {analytics.appEventsConfigured && analytics.appEvents?.length ? analytics.appEvents.length : '—'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>App event types</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      p: 3,
                      background: 'linear-gradient(135deg, rgba(67, 233, 123, 0.1) 0%, rgba(56, 249, 215, 0.1) 100%)',
                      borderRadius: 3,
                      textAlign: 'center',
                      border: '1px solid rgba(67, 233, 123, 0.2)',
                      transition: 'all 0.3s ease',
                      '&:hover': { transform: 'scale(1.05)', boxShadow: '0 4px 12px rgba(67, 233, 123, 0.2)' },
                    }}
                  >
                    <Typography variant="h3" sx={{ fontWeight: 700, color: 'success.main', mb: 0.5 }}>{categories.length || 0}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>Categories</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    sx={{
                      p: 3,
                      background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.1) 0%, rgba(236, 72, 153, 0.1) 100%)',
                      borderRadius: 3,
                      textAlign: 'center',
                      border: '1px solid rgba(168, 85, 247, 0.2)',
                      transition: 'all 0.3s ease',
                      '&:hover': { transform: 'scale(1.05)', boxShadow: '0 4px 12px rgba(168, 85, 247, 0.2)' },
                    }}
                  >
                    <Typography variant="h3" sx={{ fontWeight: 700, color: 'secondary.main', mb: 0.5 }}>{tags.length || 0}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>Tags</Typography>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
